var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstantCash(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.51471 36.5439L37.0902 37.5379L37.7188 16.3154L4.14344 15.3214L3.51471 36.5439Z",
    fill: "#FF5200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8381 19.1613L30.8117 19.7475C30.7522 21.778 32.3494 23.4772 34.3799 23.5367L33.6748 30.0105C31.6443 29.951 30.4634 31.6586 30.4039 33.6891L10.4303 33.1029C10.4897 31.0724 8.89252 29.3733 6.86202 29.3138L7.05746 22.7211C9.08796 22.7805 10.7871 21.1833 10.8466 19.1528L10.8381 19.1613Z",
    fill: "#FFE8DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05859 20.7245L3.59983 28.0734L6.82823 29.1609L7.04062 22.5257L4.05859 20.7161V20.7245Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3324 33.9187L6.82796 29.1695L7.04035 22.5343L33.8956 25.083L32.3324 33.9187Z",
    fill: "#CC4200"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 21.8037L32.3325 33.9187L39.9957 14.115L8.66318 2L1 21.8037Z",
    fill: "#FF5200"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6928 7.85364L32.3326 15.0666C31.602 16.9612 32.5365 19.0936 34.4396 19.8242L32.0608 25.9752C30.1662 25.2446 28.0337 26.1791 27.3031 28.0821L8.66328 20.8692C9.39392 18.9746 8.4594 16.8422 6.55634 16.1116L8.93515 9.96061C10.8297 10.6912 12.9622 9.7567 13.6928 7.85364Z",
    fill: "#FFE8DC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5914 22.0078C22.5151 22.0078 24.0746 20.4483 24.0746 18.5245C24.0746 16.6008 22.5151 15.0413 20.5914 15.0413C18.6676 15.0413 17.1081 16.6008 17.1081 18.5245C17.1081 20.4483 18.6676 22.0078 20.5914 22.0078Z",
    fill: "#FF5200"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1228 10H34.8772C34.8772 8.41459 33.5907 7.12277 32 7.12277V6.8772C33.5854 6.8772 34.8772 5.59075 34.8772 4H35.1228C35.1228 5.58541 36.4093 6.8772 38 6.8772V7.12277C36.4146 7.12277 35.1228 8.40925 35.1228 10Z",
    fill: "#FF5200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantCash);
export default __webpack_public_path__ + "static/media/instant_cash.1df53ca3d2d4e46e501771e4f2ea9c72.svg";
export { ForwardRef as ReactComponent };